import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    AppBar, Avatar, Box, Divider, IconButton, InputAdornment, ListItemIcon, Menu, MenuItem,
    TextField, Toolbar, Tooltip, Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import { logoutUser } from '../../actions/authenticateActions';
import { searchInvoice, clearSearchInvoice } from '../../actions/invoiceDateActions.js';
import { getPermissionByName } from '../../util/customMethods';
import { tokens } from '../../theme';

const PAGE_TITLES = [
    ['/dashboard', 'Dashboard'],
    ['/newRequest', 'New service request'],
    ['/map', 'Map'],
    ['/search', 'Invoice search'],
    ['/ars-usage-report', 'ARS usage report'],
    ['/response-report-spd', 'Response time report'],
    ['/response-report', 'Response time report'],
    ['/home/attachments', 'Tow sheet attachments'],
    ['/home', 'Tow sheets'],
    ['/invoice/', 'Invoice details'],
];

const pageTitle = (path) => {
    const match = PAGE_TITLES.find(([prefix]) => path.startsWith(prefix));
    return match ? match[1] : '';
};

class Header extends Component {
    state = { menuAnchor: null, searchValue: '' };

    handleLogout = () => {
        this.setState({ menuAnchor: null });
        const done = () => {
            localStorage.clear();
            this.props.history.push('/login');
        };
        this.props.dispatch(logoutUser(done, done));
    };

    handleSearch = (event) => {
        if (event.key === 'Enter' && this.state.searchValue.trim()) {
            this.props.dispatch(searchInvoice(this.state.searchValue.trim()));
            this.props.history.push('/home');
        }
    };

    clearSearch = () => {
        this.setState({ searchValue: '' });
        this.props.dispatch(clearSearchInvoice());
    };

    render() {
        const { location, authInfo, onMenuClick, drawerWidth } = this.props;
        const { menuAnchor, searchValue } = this.state;
        const user = (authInfo && (authInfo.userId || authInfo.email || authInfo.userName)) || '';
        const initial = user ? user.charAt(0).toUpperCase() : '?';

        return (
            <AppBar
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                    ml: { md: `${drawerWidth}px` },
                    bgcolor: 'background.paper',
                    borderBottom: `1px solid ${tokens.line}`,
                }}
            >
                <Toolbar sx={{ gap: 1.5, minHeight: { xs: 60, md: 64 } }}>
                    <IconButton edge="start" onClick={onMenuClick} sx={{ display: { md: 'none' } }} aria-label="Open menu">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h5" component="h1" noWrap sx={{ flex: 1, minWidth: 0 }}>
                        {pageTitle(location.pathname)}
                    </Typography>

                    {getPermissionByName('towSheets') && (
                        <TextField
                            placeholder="Find a tow sheet by invoice #"
                            value={searchValue}
                            onChange={(e) => this.setState({ searchValue: e.target.value })}
                            onKeyDown={this.handleSearch}
                            sx={{ width: 300, display: { xs: 'none', sm: 'block' } }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: searchValue ? (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={this.clearSearch} aria-label="Clear search">
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                            }}
                        />
                    )}

                    <Tooltip title="Account">
                        <IconButton onClick={(e) => this.setState({ menuAnchor: e.currentTarget })} aria-label="Account menu">
                            <Avatar sx={{ width: 34, height: 34, bgcolor: tokens.blue, fontSize: 15 }}>{initial}</Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor)}
                        onClose={() => this.setState({ menuAnchor: null })}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{ variant: 'outlined', sx: { mt: 1, minWidth: 220 } }}
                    >
                        <Box sx={{ px: 2, py: 1.25 }}>
                            <Typography variant="caption" color="text.secondary">
                                Signed in as
                            </Typography>
                            <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
                                {user}
                            </Typography>
                        </Box>
                        <Divider />
                        <MenuItem onClick={this.handleLogout}>
                            <ListItemIcon>
                                <LogoutIcon fontSize="small" />
                            </ListItemIcon>
                            Sign out
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = (state) => ({ authInfo: state.authInfo });

export default withRouter(connect(mapStateToProps)(Header));
